import React, { useContext, useEffect, useState } from 'react';
import { generateTextField } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import { Add, Save } from '@mui/icons-material';
import './LabelDetailsModal.css';
import { ButtonGroup, IconButton, Typography } from '@mui/material';
import { LocaleTabs, TabPanel, TranslationTextField } from '../components/helper';
import { saveNewTranslation } from '../../../services/b2b-languages-apiService';
import LocaleNewDialog from '../components/LocaleNewDialog';

const LabelNewModal = ({ open, labelTranslations, onClose }) => {
    const { loginData } = useContext(LoginContext);
    const [tabValue, setTabValue] = useState(0);
    const [translations, setTranslations] = useState(labelTranslations);

    useEffect(() => {
        setTranslations(labelTranslations);
    }, [labelTranslations]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleSaveTranslations = async () => {
        try {
            for (const translation of translations.sameLabelTranslations)
                await saveNewTranslation(translation, loginData.accessToken);
            console.log('All translations saved successfully.');
        } catch (error) {
            console.error('Error saving translations:', error);
        }
    };

    const handleTranslationChange = (index, newContent) => {
        setTranslations(prevTranslations => {
            const updatedTranslations = [...prevTranslations.sameLabelTranslations];
            updatedTranslations[index] = { ...updatedTranslations[index], content: newContent };
            return { ...prevTranslations, sameLabelTranslations: updatedTranslations };
        });
    };

    const [showLocaleRequest, setShowLocaleRequest] = useState(false);

    const handleAddingNewLocale = async (newLocale) => {
        const newTranslation = {
            "languageId": null,
            "locale": newLocale,
            "key": translations.sameLabelTranslations[0].key,
            "content": ""
        }
        setTranslations(prevState => ({
            ...prevState,
            sameLabelTranslations: [...prevState.sameLabelTranslations, newTranslation]
        }));
        setShowLocaleRequest(false)
    }

    const translationsButtons = [
        <IconButton
            key="new"
            onClick={() => setShowLocaleRequest(true)}
            className="translations-management-button"
        >
            <Add />
            <Typography variant="body2">New Locale</Typography>
        </IconButton>,
    ];

    //console.log("LabelNewModal", translations);
    const checkConditions = translations && translations.sameLabelTranslations && translations.sameLabelTranslations.length > 0;
    return (
        <>
            <B2BPopUpForm
                open={open}
                title={<span>Label key translations</span>}
                buttons={[
                    {
                        label: 'Save all translations',
                        confirm: true,
                        onConfirm: handleSaveTranslations,
                        icon: <Save />
                    },
                ]}
                onClose={onClose}
                className={'label-translations-modal'}
            >
                {translations && (
                    <>
                        {generateTextField("Key", (checkConditions) ? translations.sameLabelTranslations[0].key : "", "label-key-ro-textfield")}
                        <ButtonGroup size="small" aria-label="small button group" className="b2b-default-button-group">
                            {translationsButtons}
                        </ButtonGroup>
                        <LocaleTabs
                            value={tabValue}
                            translations={translations}
                            onTabChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="false"
                            aria-label="translation tabs"
                        />
                        {checkConditions && translations.sameLabelTranslations.map((translation, index) => (
                            <TabPanel key={index} value={tabValue} index={index} className='tab-panel-locale-translation'>
                                <TranslationTextField translation={translation}
                                    index={index} onTranslationChange={handleTranslationChange} />
                            </TabPanel>
                        ))}
                    </>
                )}
            </B2BPopUpForm>
            {
                showLocaleRequest && <LocaleNewDialog onAddingNewLocale={handleAddingNewLocale} />
            }
        </>
    )
}

export default LabelNewModal;